export default __webpack_public_path__ + "static/seo-partner-83df9e81fc3ff4a5eec7ac188b573579.webp";